module.exports = __webpack_public_path__ + "img/BeginnersGroups.fb5a7448.webp";